<template>
  <div class="lobbying-chart graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
    <h3 class="chart-hed" v-if="showHeading">Medical supplies industry spends millions to influence US lawmakers</h3>
    <p v-if="showDeck">The medical devices and supplies industry spent more than $335 million on lobbying in a decade.</p>
    <column-chart :chart-height-ratio="baseHeightRatio" :chart-data="lobbyingData" :chart-options="lobbyingChartOptions"></column-chart>
    <p class="chart-source">Source: <a href="https://www.opensecrets.org/lobby/induscode.php?id=H4100&year=2017">Center for Responsive Politics</a></p>
  </div>
</template>

<script>
  import lobbyingData from '../assets/lobbying.json'
  import ColumnChart from '@/components/ColumnChart.vue'
  import embeddable from '../mixins/embeddable'

  export default {
    name: 'LobbyingChart',
    mixins: [embeddable],
    components: {
      ColumnChart,
    },
    data() {
      return {
        lobbyingData,
        lobbyingChartOptions: {
          chartName: "lobbying",
          seriesName: "lobbyingAmount",
          labelWidth: "45",
          barColor: "#3B98AB",
          xAxisTickFormat: this.xAxisYearFormat,
          yAxisTickFormat: function(d) {return d === 0 ? d : "$" + d/1000000 + "m";},
          yAxisTicks: 5,
        }
      }
    }
  }
</script>
